import { render, staticRenderFns } from "./cap.vue?vue&type=template&id=05b85a86&scoped=true"
import script from "./cap.vue?vue&type=script&lang=js"
export * from "./cap.vue?vue&type=script&lang=js"
import style0 from "./cap.vue?vue&type=style&index=0&id=05b85a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b85a86",
  null
  
)

export default component.exports